// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"recorder_wrapper__86YRn","recorderImg":"recorder_recorderImg__1EAMu","lineBox":"recorder_lineBox__287FM","line":"recorder_line__1Ql6J"};